import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          customer: Yup.string()
                                                       .required('Required'),
                                          items: Yup.array(),
                                      });


